import { enableProdMode } from '@angular/core';
import '@angular/compiler';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { akitaConfig } from '@datorama/akita';
import { startPersistEngine } from '@persistence/localforage.settings';
import { defineCustomElements } from '@ionic/pwa-elements/loader';
// Valuta tutti i trii iid* (store/query/service): registra @PersistedStoreConfig e @InterfaceData*
// PRIMA che il body chiami startPersistEngine() (contratto pendingKeyCount, vedi commento sotto).
// Prima era garantito dagli import di interfaceDataMapping.ts via AppComponent -> ClientMessagesService.
import '@ep-om/project/state/interfaceData.barrel';

akitaConfig({ resettable: true });

/* const initSentry = () => {
  Sentry.init({
    dsn: 'https://b2af8332e38f486d910f06b79df66365@o495789.ingest.sentry.io/5569161',
    autoSessionTracking: true,
    integrations: [
      new Integrations.BrowserTracing({
        tracingOrigins: ['localhost', 'https://jira.trungk18.com/'],
        routingInstrumentation: Sentry.routingInstrumentation
      })
    ],

    tracesSampleRate: 1.0
  });
}; */

if (environment.production) {
  enableProdMode();
  //initSentry();
}

// Il bootstrap attende che tutte le persistState abbiano completato l'init: il primo store Akita
// viene creato da Angular durante il bootstrap, e se venisse creato prima di quelle sottoscrizioni
// potrebbe non essere idratato mai piu' (vedi startPersistEngine). La chiamata avviene qui nel body
// perche' a questo punto tutto il grafo eager (import di AppModule e di interfaceData.barrel qui
// sopra) e' gia' stato valutato e ogni @PersistedStoreConfig si e' gia' registrato. L'attesa e' a
// tempo: se IDB non risponde si parte comunque, con gli store vuoti.
startPersistEngine().then(() => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
});

// Call the element loader after the platform has been bootstrapped
defineCustomElements(window);
